import { Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ControlPanelService } from 'src/app/services/control-panel.service';
import { environment as env } from '@env';
import { ActivatedRoute, Route, Router } from '@angular/router';

@Component({
  selector: 'app-ecg-file-management',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ecg-file-management.component.html',
  styleUrl: './ecg-file-management.component.css',
})
export class EcgFileManagementComponent {
  private subscription: Subscription = new Subscription();
  @ViewChild('fileInput')
  fileInput!: ElementRef;

  uploading = false;
  ecgPreviewAvailable = false;
  ecgPreview: any;

  routerId: any;
  routerName: any;

  showListECGPreview = false;
  listECGPreview: any;

  screenHeight: any;
  screenWidth: any;

  routesArray = null;
  urlParams: any;
  userInfo: any;

  patientDynamicId: any;

  ecgFiles: any[] = [];

  formUploading = false;
  contentLoading = true;

  pageType = 'edit';

  constructor(
    public bsModalRef: BsModalRef,
    public bsModalRefOne: BsModalRef,
    public bsModalRefTwo: BsModalRef,
    private modalService: BsModalService,
    public _DomSanitizationService: DomSanitizer,
    public ecgService: ControlPanelService,
    public activeRoute: ActivatedRoute,
    public router: Router
  ) {
    this.patientDynamicId =this.activeRoute.snapshot.queryParamMap.get('id');

  }

  ngOnInit() {
    this.getScreenSize();
    const patientId = this.patientDynamicId;

    this.ecgService.getAllEcgFiles(patientId).subscribe({
      next: (data) => {
        // console.log("data ecg", data);

        this.ecgFiles = data;
        this.contentLoading = false;
      },
      error: (err) => {
        console.error('Error fetching ECG files:', err);
        this.contentLoading = false;
      },
    });
  }

  openUploadModel(template: TemplateRef<any>) {
    this.bsModalRefOne = this.modalService.show(template, { class: 'second' });
  }

  openListModel(template: TemplateRef<any>, index: any) {
    // console.log(this.ecgFiles[index].ECG_File);
    const filePath = `${env.apiImgUrl}ecg-files/${this.ecgFiles[index].fileName}`;
    // console.log(filePath);
    this.listECGPreview =
      this._DomSanitizationService.bypassSecurityTrustUrl(filePath);
    this.bsModalRefTwo = this.modalService.show(template, { class: 'second' });
  }

  getScreenSize(event?: any) {
    this.screenHeight = window.innerHeight - 80;
    this.screenWidth = window.innerWidth - 40;
  }

  onFileChange(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (events) => {
        this.ecgPreview = (events.target as FileReader)?.result;
        this.ecgPreviewAvailable = true;
      };
    } else {
      this.fileInput.nativeElement.value = null;
      this.ecgPreviewAvailable = false;
      this.ecgPreview = null;
    }
  }

  update_ECG() {
    if (this.ecgPreviewAvailable && !this.formUploading) {
      this.formUploading = true;

      const file = this.fileInput.nativeElement.files[0];
      if (!file) {
        this.formUploading = false;
        return;
      }

      const patientId = this.patientDynamicId;

      this.ecgService.uploadFollowUpEcg(patientId, file).subscribe({
        next: (response) => {
          // console.log('Upload success:', response);

          // ✅ Add this block here
          const file = response.data;
          file.createdAt = new Date(); // fallback
          file.fileUrl = `${env.apiImgUrl}ecg-files/${file.fileName}`;
          this.ecgFiles.unshift(file); // Add to top of list

          this.formUploading = false;
          this.ecgPreviewAvailable = false;
          this.ecgPreview = null;
          this.fileInput.nativeElement.value = null;
        },
        error: (error) => {
          console.error('Upload failed:', error);
          this.formUploading = false;
        }
      });
    }
  }
}
